import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ConnectToChannelManuallyPopup = loadAsyncComponent(
  () => import('./Container'),
  'popup'
);
